/* eslint-disable */
import "./App.css";
import React, { act, useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { t } from "i18next";
import ThemeProvider from "theme";
import dayjs from "dayjs";
import Cookie from "js-cookie";
import useCart from "store";
import { ASC_SORT } from "utils/function";
import Api from "utils/wApi";

// pages
import Home from "pages/Home";
import Menu from "pages/Menu";
import Detail from "pages/Detail";
import Order from "pages/Order";
import Info from "pages/Info";
import Pay from "pages/Pay";
import Complete from "pages/Complete";
import Entrance from "pages/Entrance";
import AdminLogin from "pages/admin/Login";
import AdminSetting from "pages/admin/Setting";

// component
import { CircularProgress, Container, Box, Typography } from "@mui/material";
import { CommonModal } from "components";
// notistack
import { SnackbarProvider } from "notistack";
// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ===== day.js plugin =====
var utc = require("dayjs/plugin/utc");
var timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);
// ===== day.js plugin =====

function App() {
	const navigate = useNavigate();
	const location = useLocation();
	const {
		festival,
		branchLargeList,
		branchMidList,
		branchSmallList,
		setActiveBranchList,
		setMenuList,
		removeAllCart,
	} = useCart((state) => state);

	const [id, setId] = useState(Cookie.get("Kiosk_ID"));
	const [timeLeft, setTimeLeft] = useState(15); // 타이머 값
	const [counter, setCounter] = useState(10); // 대기화면 카운트
	const [isRunning, setIsRunning] = useState(false); // 타이머 실행 상태
	const [standByModal, setStandByModal] = useState(false); // 대기화면 모달 온오프

	// 타이머 시작
	const startTimer = () => {
		setIsRunning(true);
	};

	// 타이머 초기화
	const resetTimer = () => {
		setTimeLeft(30); // 타이머 값 초기화
		setCounter(10); // 대기화면 카운트 값 초기화
		setIsRunning(false); // 타이머 중지
		setStandByModal(false); // 대기화면 모달 닫기
	};

	// 동작 없을시 메인화면으로 이동하는 타이머
	useEffect(() => {
		let timer;
		let count;

		// 메인화면에서는 타이머 중지
		if (location.pathname === "/") return;

		if (isRunning && timeLeft > 0) {
			// 타이머 실행
			timer = setTimeout(() => {
				setTimeLeft((prev) => prev - 1);
			}, 1000);
		} else if (timeLeft === 0) {
			// 타이머 종료
			setIsRunning(false);

			// 대기화면 모달 활성화
			setStandByModal(true);

			count = setTimeout(() => {
				setCounter((prev) => prev - 1);
			}, 1000);
		}

		if (counter <= 0) {
			resetTimer();
			navigate(`/?code=${id}`);
		}

		return () => {
			// 컴포넌트 언마운트 또는 상태 변경 시 타이머 정리
			clearTimeout(timer);
			clearTimeout(count);
		};
	}, [timeLeft, isRunning, counter]);

	// 키오스크 ID 체크
	useEffect(() => {
		if (typeof window !== "undefined") {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const queryValue = urlParams.get("code");
			if (process.env.NODE_ENV === "production") {
				// 운영
				if (!queryValue) {
					Cookie.remove("Kiosk_ID");
					setId(null);
				} else {
					Cookie.set("Kiosk_ID", queryValue);
					localStorage.setItem("Kiosk_ID", queryValue);
					setId(queryValue);
				}
			} else {
				// 개발
				Cookie.set("Kiosk_ID", queryValue || "K-00");
				localStorage.setItem("Kiosk_ID", queryValue || "K-00");
				setId(queryValue || "K-00");
			}
		}
	}, [window]);

	// TODO : refactoring 상품 목록 api
	const API_MENU_LIST = async (festivalId, branchSmallId) => {
		const {
			data: { data: menuListData },
		} = await Api.getProductList(null, festivalId, {
			params: {
				idBranch: festivalId,
				idBranchMenu: branchSmallId,
				menuDate: Cookie.get("qs_kiosk_date") ?? dayjs().format("YYYY-MM-DD"),
			},
		});
		// 상품 순서변경
		const changeMenuList = ASC_SORT(menuListData, "orderDescending", "idMenu");

		setMenuList(changeMenuList);
	};
	useEffect(() => {
		if (location.pathname === "/") {
			setActiveBranchList([
				branchLargeList[0]?.type ?? "",
				branchMidList[0]?.idBranchMenu ?? 0,
				branchSmallList[0]?.idBranchMenu ?? 0,
			]);
			branchSmallList.length > 0 &&
				API_MENU_LIST(
					festival.id ?? festival.branchId,
					branchSmallList[0]?.idBranchMenu ?? 0
				);

			removeAllCart();
		}
	}, [location]);
	useEffect(() => {
		// 대기화면 타이머 실행여부
		window.addEventListener("click", () => {
			try {
				resetTimer();
			} finally {
				startTimer();
			}
		});
	}, []);

	return (
		<I18nextProvider i18n={i18n}>
			<>
				{id ? (
					<SnackbarProvider
						autoHideDuration={2000}
						maxSnack={1}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
						// Components={{
						// 	default: StyledMaterialDesignContent,
						// 	success: StyledMaterialDesignContent,
						// 	error: StyledMaterialDesignContent,
						// 	warning: StyledMaterialDesignContent,
						// }}
					>
						<ThemeProvider>
							<Routes>
								<Route path="/" element={<Home />} />
								<Route path="/menus" element={<Menu />} />
								<Route path="/detail/:id" element={<Detail />} />
								<Route path="/order" element={<Order />} />
								<Route path="/info" element={<Info />} />
								<Route path="/pay" element={<Pay />} />
								<Route path="/complete" element={<Complete />} />

								{/* 관리자 페이지 */}
								<Route path="/admin/login" element={<AdminLogin />} />
								<Route path="/admin/setting" element={<AdminSetting />} />

								{/* --NFC-- */}
								{/* 입장 */}
								<Route path="/entrance" element={<Entrance />} />
							</Routes>

							{/* ----------- 대기화면 모달 ----------- */}
							<CommonModal
								open={standByModal}
								footer={{
									label: t("continue"),
								}}
								subFooter={{
									label: t("go-home"),
									onClick: () => {
										resetTimer();
										navigate(`/?code=${id}`);
									},
								}}
							>
								<Box sx={{ textAlign: "center", py: 2 }}>
									<Typography variant="h3" fontSize={24} mb={2}>
										{t("alert")}
									</Typography>
									<Typography fontSize={20} color="grey.middle">
										{t("auto-reset", { count: counter })}
									</Typography>
								</Box>
							</CommonModal>
							{/* ----------- 대기화면 모달 ----------- */}
						</ThemeProvider>
					</SnackbarProvider>
				) : (
					<Container sx={{ py: 5, display: "flex", justifyContent: "center" }}>
						<CircularProgress />
					</Container>
				)}
			</>
		</I18nextProvider>
	);
}

export default App;
